'use strict';

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var styled = require('styled-components');
var lightThemeColors = require('@prisjakt/design-tokens/light-theme-colors');
var darkThemeColors = require('@prisjakt/design-tokens/dark-theme-colors');
var measurements = require('@prisjakt/design-tokens/measurements');
var definitions = require('./definitions-4ae1604d.js');
var index = require('./index-6f152094.js');
var variants = require('./variants-434e0406.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _a$1;
exports.Radius = void 0;
(function (Radius) {
    Radius["HARD"] = "2px";
    Radius["MEDIUM"] = "4px";
    Radius["SOFT"] = "8px";
    Radius["ROUNDED1"] = "16px";
    Radius["ROUNDED2"] = "24px";
    Radius["CIRCLE"] = "999px";
})(exports.Radius || (exports.Radius = {}));
exports.Opacity = void 0;
(function (Opacity) {
    Opacity["_100"] = "6%";
    Opacity["_200"] = "12%";
    Opacity["_300"] = "24%";
    Opacity["_500"] = "48%";
    Opacity["_700"] = "72%";
    Opacity["_1000"] = "100%";
})(exports.Opacity || (exports.Opacity = {}));
exports.Size = void 0;
(function (Size) {
    Size["NORMAL"] = "normal";
    Size["SMALL"] = "small";
    Size["MEDIUM"] = "medium";
    Size["LARGE"] = "large";
})(exports.Size || (exports.Size = {}));
var scales = (_a$1 = {},
    _a$1[exports.Size.NORMAL] = {
        iconSize: 20,
        paddingText: '10px 12px',
        paddingIcon: '10px',
        textProps: variants.textProperties.titleSmall,
    },
    _a$1[exports.Size.SMALL] = {
        iconSize: 16,
        paddingText: '6px 10px',
        paddingIcon: '8px',
        textProps: variants.textProperties.titleSmall,
    },
    _a$1[exports.Size.MEDIUM] = {
        iconSize: 24,
        paddingText: '10px 12px',
        paddingIcon: '10px',
        textProps: variants.textProperties.titleMedium,
    },
    _a$1[exports.Size.LARGE] = {
        iconSize: 28,
        paddingText: '10px 16px',
        paddingIcon: '10px',
        textProps: variants.textProperties.h3,
    },
    _a$1);
exports.Type = void 0;
(function (Type) {
    Type["PRIMARY"] = "primary";
    Type["OUTLINED"] = "outlined";
    Type["TONAL"] = "tonal";
    Type["TEXT"] = "text";
})(exports.Type || (exports.Type = {}));
exports.Tone = void 0;
(function (Tone) {
    Tone["LIGHT"] = "light";
    Tone["DARK"] = "dark";
})(exports.Tone || (exports.Tone = {}));

var _a, _b, _c, _d;
var shadows = tslib.__assign(tslib.__assign({}, definitions.shadows), (_a = {}, _a[exports.Type.OUTLINED] = "0 0 0 1px ".concat(definitions.setRgbaAlpha(lightThemeColors.base800, 0.12)), _a.selected = "0 0 0 2px ".concat(lightThemeColors.maybeBlue500), _a));
var colors = (_b = {},
    _b[exports.Tone.LIGHT] = (_c = {},
        _c[exports.Type.PRIMARY] = {
            bg: lightThemeColors.maybeBlue500,
            bgHover: '#00A5D1',
            fg: lightThemeColors.base0,
            ol: undefined,
        },
        _c[exports.Type.OUTLINED] = {
            bg: 'transparent',
            bgHover: definitions.setRgbaAlpha(lightThemeColors.base800, 0.06),
            fg: lightThemeColors.base800,
            ol: shadows[exports.Type.OUTLINED],
        },
        _c[exports.Type.TONAL] = {
            bg: definitions.setRgbaAlpha(lightThemeColors.base800, 0.06),
            bgHover: definitions.setRgbaAlpha(lightThemeColors.base800, 0.12),
            fg: lightThemeColors.base800,
            ol: shadows[definitions.Elevation.NONE],
        },
        _c[exports.Type.TEXT] = {
            bg: 'transparent',
            bgHover: definitions.setRgbaAlpha(lightThemeColors.base800, 0.06),
            fg: lightThemeColors.maybeBlue700,
            ol: shadows[definitions.Elevation.NONE],
        },
        _c.selected = {
            fg: lightThemeColors.base800,
            ol: shadows.selected,
        },
        _c),
    _b[exports.Tone.DARK] = (_d = {},
        _d[exports.Type.PRIMARY] = {
            bg: darkThemeColors.base900,
            bgHover: '#F0F2F2',
            fg: darkThemeColors.base100,
            ol: shadows.low,
        },
        _d[exports.Type.OUTLINED] = {
            bg: 'transparent',
            bgHover: definitions.setRgbaAlpha(darkThemeColors.base900, 0.12),
            fg: darkThemeColors.base900,
            ol: "0 0 0 1px ".concat(definitions.setRgbaAlpha(darkThemeColors.base900, 0.24)),
        },
        _d[exports.Type.TONAL] = {
            bg: definitions.setRgbaAlpha(darkThemeColors.base900, 0.12),
            bgHover: definitions.setRgbaAlpha(darkThemeColors.base900, 0.24),
            fg: darkThemeColors.base900,
            ol: shadows[definitions.Elevation.NONE],
        },
        _d[exports.Type.TEXT] = {
            bg: 'transparent',
            bgHover: definitions.setRgbaAlpha(darkThemeColors.base900, 0.12),
            fg: lightThemeColors.maybeBlue500,
            ol: shadows[definitions.Elevation.NONE],
        },
        _d.selected = {
            bg: definitions.setRgbaAlpha(darkThemeColors.base900, 0.12),
            bgHover: '',
            fg: darkThemeColors.base900,
            ol: "0 0 0 2px ".concat(definitions.setRgbaAlpha(darkThemeColors.base900, 1)),
        },
        _d),
    _b);
var buttonReset = styled.css(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  display: flex;\n  border: none;\n  outline: none;\n  margin: 0;\n  padding: 0;\n  width: auto;\n  overflow: visible;\n  background: transparent;\n  appearance: none;\n  -webkit-appearance: none;\n"], ["\n  display: flex;\n  border: none;\n  outline: none;\n  margin: 0;\n  padding: 0;\n  width: auto;\n  overflow: visible;\n  background: transparent;\n  appearance: none;\n  -webkit-appearance: none;\n"])));
var StyledIcon = styled__default["default"].span.withConfig({ displayName: "StyledIcon", componentId: "-192msy9" })(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  color: inherit;\n  display: flex;\n\n  svg,\n  path {\n    fill: currentColor;\n  }\n"], ["\n  color: inherit;\n  display: flex;\n\n  svg,\n  path {\n    fill: currentColor;\n  }\n"])));
var StyledText = styled__default["default"](index.Text).withConfig({ displayName: "StyledText", componentId: "-17mnhqp" })(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  opacity: 1;\n"], ["\n  opacity: 1;\n"])));
var transition = '150ms ease';
var BaseButton = styled__default["default"].button.withConfig({ displayName: "BaseButton", componentId: "-303e6a" })(function (p) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var color = colors[p.$tone][p.$type];
    // Colors from a theme with fallback to the default `colors` and `shadows`.
    var theme = (_b = (_a = p.theme) === null || _a === void 0 ? void 0 : _a.button) === null || _b === void 0 ? void 0 : _b[p.$type];
    var outline = (theme === null || theme === void 0 ? void 0 : theme.ol) || color.ol || shadows[definitions.Elevation.NONE];
    var shadow = "".concat(shadows[p.$elevation], ", ").concat(outline);
    var shadowHover = p.$elevation !== definitions.Elevation.NONE
        ? "".concat(shadows[p.$elevationHover || p.$elevation], ", ").concat(outline)
        : "".concat(shadows[p.$elevation], ", ").concat(outline);
    return styled.css(templateObject_5 || (templateObject_5 = tslib.__makeTemplateObject(["\n    ", ";\n    position: relative;\n    align-items: center;\n    justify-content: center;\n    border-radius: ", ";\n    box-shadow: ", ";\n    opacity: ", ";\n    background-color: ", ";\n    color: ", ";\n    gap: ", ";\n    padding: ", ";\n    cursor: pointer;\n    user-select: none;\n    transition: box-shadow ", ", background-color ", ",\n      opacity ", ";\n    width: ", ";\n\n    &:hover {\n      background-color: ", ";\n      box-shadow: ", ";\n    }\n\n    &:focus-visible,\n    &.focus-visible {\n      outline: ", " 2px solid;\n    }\n\n    &:disabled {\n      pointer-events: none;\n      opacity: ", ";\n    }\n\n    ", "\n  "], ["\n    ", ";\n    position: relative;\n    align-items: center;\n    justify-content: center;\n    border-radius: ", ";\n    box-shadow: ", ";\n    opacity: ", ";\n    background-color: ", ";\n    color: ", ";\n    gap: ", ";\n    padding: ", ";\n    cursor: pointer;\n    user-select: none;\n    transition: box-shadow ", ", background-color ", ",\n      opacity ", ";\n    width: ", ";\n\n    &:hover {\n      background-color: ", ";\n      box-shadow: ", ";\n    }\n\n    &:focus-visible,\n    &.focus-visible {\n      outline: ", " 2px solid;\n    }\n\n    &:disabled {\n      pointer-events: none;\n      opacity: ", ";\n    }\n\n    ", "\n  "])), buttonReset, p.$radius, shadow, p.$opacity, (theme === null || theme === void 0 ? void 0 : theme.bg) || color.bg, (theme === null || theme === void 0 ? void 0 : theme.fg) || color.fg, measurements.spacing050, p.$padding, transition, transition, transition, p.$fullWidth ? '100%' : 'max-content', (theme === null || theme === void 0 ? void 0 : theme.bgHover) || color.bgHover, shadowHover, lightThemeColors.maybeBlue300, exports.Opacity._300, p.selected && styled.css(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n      box-shadow: ", ",\n        ", ";\n\n      &:hover {\n        box-shadow: ", ",\n          ", ";\n      }\n    "], ["\n      box-shadow: ", ",\n        ", ";\n\n      &:hover {\n        box-shadow: ", ",\n          ", ";\n      }\n    "])), shadow, ((_e = (_d = (_c = p.theme) === null || _c === void 0 ? void 0 : _c.button) === null || _d === void 0 ? void 0 : _d.selected) === null || _e === void 0 ? void 0 : _e.ol) || colors[p.$tone].selected.ol, shadow, ((_h = (_g = (_f = p.theme) === null || _f === void 0 ? void 0 : _f.button) === null || _g === void 0 ? void 0 : _g.selected) === null || _h === void 0 ? void 0 : _h.ol) || colors[p.$tone].selected.ol));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

/**
 * Applies the provided scale props to the provided children,
 * even if the children are wrapped in a React fragment.
 */
var applyScaleProps = function (children, currentScale) {
    // Scale `ButtonText` and `ButtonIcon` based on parent props when used as `children`
    return React__default["default"].Children.map(children, function (child) {
        if (React__default["default"].isValidElement(child)) {
            return child.type === React__default["default"].Fragment && child.props.children ? (applyScaleProps(child.props.children, currentScale)) : (React__default["default"].createElement(child.type, tslib.__assign({}, child.props, { size: currentScale.iconSize }, currentScale.textProps)));
        }
        // Handle scaling on text if child is a string and not a React element
        if (typeof child === 'string') {
            return React__default["default"].createElement(StyledText, tslib.__assign({}, currentScale.textProps), child);
        }
        return child;
    });
};
var Button = function (props) {
    var ariaLabel = props.ariaLabel, children = props.children, className = props.className, container = props.container, containerProps = props.containerProps, _a = props.disabled, disabled = _a === void 0 ? false : _a, _b = props.elevation, elevation = _b === void 0 ? definitions.Elevation.LOW : _b, _c = props.elevationHover, elevationHover = _c === void 0 ? undefined : _c, _d = props.fullWidth, fullWidth = _d === void 0 ? false : _d, _e = props.loading, loading = _e === void 0 ? false : _e, onClick = props.onClick, _f = props.onlyIcon, onlyIcon = _f === void 0 ? false : _f, _g = props.opacity, opacity = _g === void 0 ? exports.Opacity._1000 : _g, _h = props.radius, radius = _h === void 0 ? exports.Radius.SOFT : _h, _j = props.selectable, selectable = _j === void 0 ? false : _j, _k = props.selected, selected = _k === void 0 ? false : _k, _l = props.size, size = _l === void 0 ? exports.Size.NORMAL : _l, style = props.style, _m = props.tabIndex, tabIndex = _m === void 0 ? 0 : _m, _o = props.tone, tone = _o === void 0 ? exports.Tone.LIGHT : _o, _p = props.htmlType, htmlType = _p === void 0 ? 'button' : _p, _q = props.type, type = _q === void 0 ? exports.Type.PRIMARY : _q, variant = props.variant;
    var currentScale = scales[size];
    var isDisabled = disabled || loading;
    return (React__default["default"].createElement(BaseButton, tslib.__assign({}, containerProps, { "aria-label": ariaLabel, as: container, className: cn__default["default"](variant, className), disabled: isDisabled, style: style, type: htmlType, "$type": type, "$tone": tone, "$elevation": elevation, "$elevationHover": elevationHover, "$opacity": opacity, "$radius": radius, "$padding": onlyIcon ? currentScale.paddingIcon : currentScale.paddingText, "$size": size, "$fullWidth": fullWidth, selected: selectable && selected, "tab-index": tabIndex, onClick: onClick }), applyScaleProps(children, currentScale)));
};
var ButtonText = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style, textProps = tslib.__rest(_a, ["children", "className", "style"]);
    return (React__default["default"].createElement(StyledText, tslib.__assign({ className: className }, textProps, { style: style }), children));
};
function ButtonIcon(_a) {
    var children = _a.children, className = _a.className, size = _a.size;
    return (React__default["default"].createElement(StyledIcon, { className: className }, React__default["default"].Children.map(children, function (child) {
        if (React__default["default"].isValidElement(child)) {
            // Adds `size` props to the icon
            return React__default["default"].createElement(child.type, tslib.__assign({}, child.props, { size: size }));
        }
        return child;
    })));
}

exports.Button = Button;
exports.ButtonIcon = ButtonIcon;
exports.ButtonText = ButtonText;
//# sourceMappingURL=index-70540d0b.js.map
